import { jsx as _jsx } from "react/jsx-runtime";
// One tone per variant. The shell flips every `--color-*` token under its `.dark` class (the
// header of `@zion/design-tokens/tokens.css`), so a variant names tokens and carries no `dark:`
// variant: Tailwind compiles `dark:` to `prefers-color-scheme`, which follows the OS and not the
// shell's polarity. The label is `text-secondary` on a 10% tint of the tone in every variant,
// because `text-state-*` on its own tint falls under 4.5:1 in light polarity (warning 2.68:1,
// success 2.76:1, critical 3.87:1), as `ErrorBanner`'s warning tone already found. The tint and
// the inset ring carry the tone; the ring changes no layout. A 10% tint of any colour keeps
// `text-secondary` at 6.93:1 or better, so a tenant's branded accent cannot break the label.
const NEUTRAL = 'bg-surface-muted text-secondary ring-1 ring-inset ring-border-subtle';
const TONE = {
    info: 'bg-state-info/10 text-secondary ring-1 ring-inset ring-state-info/40',
    warning: 'bg-state-warning/10 text-secondary ring-1 ring-inset ring-state-warning/40',
    success: 'bg-state-success/10 text-secondary ring-1 ring-inset ring-state-success/40',
    critical: 'bg-state-critical/10 text-secondary ring-1 ring-inset ring-state-critical/40',
    accentSecondary: 'bg-accent-secondary/10 text-secondary ring-1 ring-inset ring-accent-secondary/40',
    accentTertiary: 'bg-accent-tertiary/10 text-secondary ring-1 ring-inset ring-accent-tertiary/40',
};
const VARIANT_CLASSES = {
    // Role badges
    owner: TONE.accentSecondary,
    admin: TONE.info,
    member: NEUTRAL,
    'site-admin': TONE.warning,
    'site-auditor': TONE.accentTertiary,
    // Invitation status
    pending: TONE.warning,
    accepted: TONE.success,
    revoked: TONE.critical,
    expired: NEUTRAL,
    // Entity status
    active: TONE.success,
    archived: NEUTRAL,
    // Semantic
    info: TONE.info,
    warning: TONE.warning,
    success: TONE.success,
    error: TONE.critical,
};
/**
 * Token-mapped badge: maps a role or status name to design-token colour classes. The label holds
 * 4.5:1 or better against its tint over `surface` and `surface-elevated` in both polarities.
 */
export function Badge({ variant, children }) {
    const classes = VARIANT_CLASSES[variant];
    return (_jsx("span", { className: `inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${classes}`, "data-variant": variant, children: children }));
}
//# sourceMappingURL=Badge.js.map